<template>
	<!-- 健康档案对话框 -->
	<el-dialog 
      :title="dialogTitle" 
      :visible.sync="dialogVisible" 
      width="68%" 
      :before-close="handleClose" 
      top="8px"
      :close-on-click-modal="false"
    >
      <div class="form">
        <el-tabs v-model="activeName" type="card" @tab-click="handleTabClick">
          <!-- 基本信息标签页 -->
          <el-tab-pane label="基本信息" name="first">
            <!-- 表单1 -->
            <div class="headerForm">
              <el-form 
                :rules="addRules" 
                :model="addForm" 
                ref="addForm" 
                size="mini"
                :disabled="mode === 'view'"
                label-position="left"
              >
                <el-row :gutter="20">
                  <!-- 每行显示4个字段 -->
                  <el-col 
                    v-for="(v,i) in getOrderedFormFields()" 
                    :key="i"
                    :xs="v.xs || 6" 
                    :sm="v.sm || 6" 
                    :md="v.md || 6" 
                    :lg="v.lg || 6" 
                    :xl="v.xl || 6"
                  >
                    <!-- select -->
                    <el-form-item v-if="v.type == 'select'" :label="v.label" :prop="v.modelValue" class="compact-form-item">
                      <el-select 
                        v-model="$data.addForm[v.modelValue]" 
                        @focus="handlefoucs(v,i)" 
                        filterable
                        :disabled="v.disabled || mode === 'view'"
                        :clearable="mode !== 'view'"
                      >
                        <el-option 
                          v-for="item in $data[v.op]" 
                          :key="item.id" 
                          :label="item.label" 
                          :value="item.id"
                        >
                          <span style="font-size: 12px;">{{ item.label }}</span>
                        </el-option>
                      </el-select>
                    </el-form-item>
                    
                    <!-- input -->
                    <el-form-item v-if="v.type == 'input'" :label="v.label" :prop="v.modelValue" class="compact-form-item">
                      <el-input 
                        v-model="$data.addForm[v.modelValue]" 
                        @blur="validateAndCompute(v,i)" 
                        :disabled="v.disabled || mode === 'view'"
                        :clearable="mode !== 'view'"
                      ></el-input>
                    </el-form-item>
                    
                    <!-- 生肖显示 -->
                    <el-form-item v-if="v.type == 'inputIcon'" :label="v.label" :prop="v.modelValue" class="compact-form-item">
                      <el-input 
                        :disabled="v.disabled || mode === 'view'" 
                        v-model="Zodiac" 
                        :suffix-icon="getZodiacIcon"
                        readonly
                      >
                        <template v-slot:suffix>
                          <i :class="getZodiacIcon"></i>
                        </template>
                      </el-input>
                    </el-form-item>
                    
                    <!-- checkbox -->
                    <el-form-item v-if="v.type == 'checked'" :label="v.label" :prop="v.modelValue" class="compact-form-item">
                      <el-checkbox 
                        v-model="isChecked" 
                        @change="toggleYesNo"
                        :disabled="mode === 'view'"
                      ></el-checkbox>
                    </el-form-item>
                    
                    <!-- date -->
                    <el-form-item v-if="v.type == 'date'" :label="v.label" :prop="v.modelValue" class="compact-form-item">
                      <el-date-picker 
                        v-model="$data.addForm[v.modelValue]" 
                        value-format="yyyy-MM-dd" 
                        type="date" 
                        :picker-options="pickerOptions"
                        :disabled="mode === 'view'"
                      ></el-date-picker>
                    </el-form-item>
                    
                   <!-- 联系地址 -->
                   <el-form-item 
                     v-if="v.type == 'cascader' && v.modelValue === 'conerAddCode'" 
                     label="联系地址" 
                     prop="conerAddCode" 
                     class="compact-form-item"
                   >
                     <div style="display: flex; align-items: center; width: 100%;">
                       <!-- 左侧级联选择器 -->
                       <el-cascader 
                         placeholder="请选择省市区"
                         :props="caserProps"
                         v-model="contactAddressSelected"
                         @change="handleContactAddressChange"
                         :disabled="mode === 'view'"
                         style="flex: 1; margin-right: 8px;"
                         clearable
                         :show-all-levels="true"
                         popper-class="address-cascader"
                         separator=" / "
                       ></el-cascader>
                       
                       <!-- 右侧输入框 -->
                       <el-input 
                         v-model="contactAddressDetail"
                         placeholder="请输入详细地址（如门牌号）"
                         @change="handleAddressDetailChange"
                         :disabled="mode === 'view'"
                         style="flex: 1;"
                       ></el-input>
                     </div>
                   </el-form-item>
                    
                    <!-- cascader2 -->
                    <el-form-item v-if="v.type == 'cascader2'" :label="v.label" :prop="v.modelValue" class="compact-form-item">
                      <el-cascader 
                        :props="{value: 'areaCode', label: 'areaName' }" 
                        :options="ssqOptions" 
                        @focus="focusChangeCase(i)" 
                        @expand-change="expandChange" 
                        @change="handleChangeCasc"
                        :disabled="mode === 'view'"
                      ></el-cascader>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
            </div>
            
            <!-- 表单2数据 -->
            <div class="mainForm" v-if="formMainType && formMainType.length > 0">
              <el-form :model="addMainForm" ref="addMainForm" size="mini" :disabled="mode === 'view'">
                <el-row :gutter="20">
                  <el-col 
                    v-for="(v,i) in formMainType" 
                    :key="i"
                    :xs="v.xs || 6" 
                    :sm="v.sm || 6" 
                    :md="v.md || 6" 
                    :lg="v.lg || 6" 
                    :xl="v.xl || 6"
                  >
                    <!-- select -->
                    <el-form-item v-if="v.type == 'select'" :label="v.label" :prop="v.modelValue" class="compact-form-item">
                      <el-select 
                        v-model="$data.addForm[v.modelValue]" 
                        @focus="handlefoucs(v,i)" 
                        :disabled="mode === 'view'"
                      >
                        <el-option v-for="item in $data[v.op]" :key="item.id" :label="item.label" :value="item.id">
                          <div style="font-size: 12px;display: flex;justify-content: space-between;align-items: center;">
                            <span>{{ item.id }}</span>
                            <span>{{ item.label }}</span>
                            <span>{{ item.code }}</span>
                          </div>
                        </el-option>
                      </el-select>
                    </el-form-item>
                    
                    <!-- input -->
                    <el-form-item v-if="v.type == 'input'" :label="v.label" :prop="v.modelValue" class="compact-form-item">
                      <el-input 
                        v-model="$data.addForm[v.modelValue]" 
                        :disabled="v.disabled || mode === 'view'"
                      ></el-input>
                    </el-form-item>
                    
                    <!-- date -->
                    <el-form-item v-if="v.type == 'date'" :label="v.label" :prop="v.modelValue" class="compact-form-item">
                      <el-date-picker 
                        v-model="$data.addForm[v.modelValue]" 
                        align="right" 
                        type="date" 
                        :picker-options="pickerOptions"
                        :disabled="mode === 'view'"
                      ></el-date-picker>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
            </div>
          </el-tab-pane>
          
          <!-- 过敏记录标签页 -->
          <el-tab-pane label="过敏记录" name="second">
            <div class="allergy-container">
              <div style="display: flex;justify-content: space-between;background: #00557f;align-items: center;padding: 8px 12px;">
                <span style="font-size: 12px;color: #fff;">过敏记录</span>
                <li style="list-style-type: none;" v-if="mode !== 'view'">
                  <el-button 
                    style="color: aliceblue;" 
                    type="text" 
                    icon="el-icon-plus" 
                    size="medium" 
                    @click="tableBtnHandClick"
                  ></el-button>
                </li>
              </div>
              <el-table :data="aiseChosedData" border v-if="mode === 'edit' || mode === 'view'">
                <el-table-column fixed="left" label="#" type="index" width="50" align="center"></el-table-column>
                <el-table-column label="过敏原名称" width="120">
                  <template slot-scope="scope">
                    <span>{{ scope.row.name || getAiseNameById(scope.row.aiseId) || '未知' }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="类型" width="100">
                  <template slot-scope="scope">
                    <el-tag :type="scope.row.type === 1 ? 'warning' : 'info'" size="small">
                      {{ aiseMap[scope.row.type] || '未知' }}
                    </el-tag>
                  </template>
                </el-table-column>
                <el-table-column label="过敏描述" width="180" show-overflow-tooltip>
                  <template slot-scope="scope">
                    <span>{{ getAlgsDeseText(scope.row) }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="数据来源" width="100">
                  <template slot-scope="scope">
                    <el-tag :type="scope.row.dataSource === 1 ? 'primary' : 'success'" size="small">
                      {{ dataFromMap[scope.row.dataSource] || '未知' }}
                    </el-tag>
                  </template>
                </el-table-column>
                <!-- 操作列 -->
                <el-table-column fixed="right" label="操作" width="200" align="center" v-if="mode === 'edit'">
                  <template slot-scope="scope">
                    <el-button
                      type="primary"
                      size="mini"
                      @click="handleEditAllergy(scope.row, scope.$index)"
                      icon="el-icon-edit"
                    >修改</el-button>
                    <el-button
                      type="danger"
                      size="mini"
                      @click="handleRemoveAllergy(scope.row)"
                      icon="el-icon-delete"
                    >移除</el-button>
                  </template>
                </el-table-column>
              </el-table>
              <div v-else class="no-data-hint" style="padding: 20px; text-align: center; color: #999;">
                暂无数据，请在保存基本信息后添加过敏记录
              </div>
            </div>
          </el-tab-pane>
          
          <!-- 关联信息标签页 -->
          <el-tab-pane label="关联信息" name="third">
            <div class="relation-container">
              <div style="display: flex;justify-content: space-between;background: #00557f;align-items: center;padding: 8px 12px;">
                <span style="font-size: 12px;color: #fff;">关联信息</span>
                <li style="list-style-type: none;" v-if="mode !== 'view'">
                  <el-button 
                    style="color: aliceblue;" 
                    type="text" 
                    icon="el-icon-plus" 
                    size="medium" 
                    @click="openAddRelationDialog"
                  ></el-button>
                </li>
              </div>
              <el-table :data="relationData" border v-if="mode !== 'add'">
                <el-table-column fixed="left" label="#" type="index" width="50"></el-table-column>
                <el-table-column label="姓名" prop="name" width="100"></el-table-column>
                <el-table-column label="性别" width="80">
                  <template slot-scope="scope">
                    {{ getSexText(scope.row.sex) }}
                  </template>
                </el-table-column>
                <el-table-column label="联系电话" prop="tel" width="120"></el-table-column>
                <el-table-column label="证件号码" prop="certNo" width="180"></el-table-column>
                <el-table-column label="关联档案序号" prop="relationId" width="120"></el-table-column>
                <el-table-column label="备注" prop="remark" width="150" show-overflow-tooltip></el-table-column>
                <!-- 操作列 -->
                <el-table-column fixed="right" label="操作" width="240" align="center" v-if="mode === 'edit'">
                  <template slot-scope="scope">
                    <el-button
                      type="primary"
                      size="mini"
                      @click="handleReRelation(scope.row)"
                      icon="el-icon-refresh"
                    >重新关联</el-button>
                    <el-button
                      type="danger"
                      size="mini"
                      @click="handleCancelRelation(scope.row)"
                      icon="el-icon-delete"
                    >取消关联</el-button>
                  </template>
                </el-table-column>
              </el-table>
              <div v-else class="no-data-hint" style="padding: 20px; text-align: center; color: #999;">
                暂无数据，请在保存基本信息后添加关联信息
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
		
		<!-- 添加关联信息对话框 -->
		<el-dialog
		  :title="relationDialogTitle"
		  :visible.sync="addRelationDialogVisible"
		  width="900px"
		  :before-close="handleRelationDialogClose"
		>
		  <el-form :model="relationForm" ref="relationForm" size="mini" label-width="100px">
		    <el-form-item label="数据来源" prop="isNormal">
		      <el-checkbox v-model="isNormalData" @change="handleNormalChange">
		        {{ isNormalData ? '正常数据' : '自动生成' }}
		      </el-checkbox>
		    </el-form-item>
		    
		    <el-form-item label="关联人员" prop="relationId" required>
		      <el-select
		        v-model="relationForm.relationId"
		        placeholder="请选择关联人员"
		        filterable
		        clearable
		        :loading="relationLoading"
		        style="width: 100%;"
		        @focus="handleRelationSelectFocus"
		        @change="handleRelationSelectChange"
		        :popper-append-to-body="false"
		        popper-class="relation-select-popper"
		        @visible-change="handleSelectVisible"
				value-key="id"
		      >
		        <!-- 下拉框表头 -->
		        <div v-if="showRelationHeader" class="relation-header-container" slot="prefix">
		          <div class="relation-header-row">
		            <div class="relation-header-cell" style="flex: 1; min-width: 80px;">姓名</div>
		            <div class="relation-header-cell" style="flex: 1; min-width: 60px;">性别</div>
		            <div class="relation-header-cell" style="flex: 1; min-width: 60px;">年龄</div>
		            <div class="relation-header-cell" style="flex: 1; min-width: 80px;">民族</div>
		            <div class="relation-header-cell" style="flex: 1; min-width: 80px;">国籍</div>
		            <div class="relation-header-cell" style="flex: 1; min-width: 120px;">证件号码</div>
		            <div class="relation-header-cell" style="flex: 1; min-width: 100px;">职业</div>
		          </div>
		        </div>
		        
		        <!-- 关联人员选项 -->
		        <el-option
		          v-for="item in filteredRelationOptions"
		          :key="item.id"
		          :label="`${item.name || '无名氏'} (${item.certNo || item.certno || '无证件'})`"
		          :value="item.id"
		          :disabled="item.id === addForm.id"
		        >
		          <!-- 使用el-tooltip包裹选项内容 -->
		          <el-tooltip
		            v-if="item.id === addForm.id"
		            effect="dark"
		            content="同一人员不能相互关联！"
		            placement="top"
		            v-model="showRelationTooltip"
		          >
		            <div 
		              class="relation-option-content"
		              @mouseenter="handleOptionMouseEnter(item)"
		              @mouseleave="handleOptionMouseLeave"
		            >
		              <div class="relation-data-cell" style="flex: 1; min-width: 80px;">{{ item.name || '--' }}</div>
		              <div class="relation-data-cell" style="flex: 1; min-width: 60px;">{{ getSexText(item.sex) }}</div>
		              <div class="relation-data-cell" style="flex: 1; min-width: 60px;">{{ item.age || '--' }}</div>
		              <div class="relation-data-cell" style="flex: 1; min-width: 80px;">{{ getNatyText(item.naty) }}</div>
		              <div class="relation-data-cell" style="flex: 1; min-width: 80px;">{{ getNtlyText(item.ntlyId) }}</div>
		              <div class="relation-data-cell" style="flex: 1; min-width: 120px;">{{ item.certNo || item.certno || '--' }}</div>
		              <div class="relation-data-cell" style="flex: 1; min-width: 100px;">{{ getJobText(item.jobId) }}</div>
		            </div>
		          </el-tooltip>
		          
		          <!-- 非禁用选项的内容 -->
		          <div 
		            v-else
		            class="relation-option-content"
		            @mouseenter="handleOptionMouseEnter(item)"
		            @mouseleave="handleOptionMouseLeave"
		          >
		            <div class="relation-data-cell" style="flex: 1; min-width: 80px;">{{ item.name || '--' }}</div>
		            <div class="relation-data-cell" style="flex: 1; min-width: 60px;">{{ getSexText(item.sex) }}</div>
		            <div class="relation-data-cell" style="flex: 1; min-width: 60px;">{{ item.age || '--' }}</div>
		            <div class="relation-data-cell" style="flex: 1; min-width: 80px;">{{ getNatyText(item.naty) }}</div>
		            <div class="relation-data-cell" style="flex: 1; min-width: 80px;">{{ getNtlyText(item.ntlyId) }}</div>
		            <div class="relation-data-cell" style="flex: 1; min-width: 120px;">{{ item.certNo || item.certno || '--' }}</div>
		            <div class="relation-data-cell" style="flex: 1; min-width: 100px;">{{ getJobText(item.jobId) }}</div>
		          </div>
		        </el-option>
		        
		        <!-- 无数据选项 -->
		        <el-option v-if="!relationLoading && relationOptions.length === 0" disabled style="text-align: center; color: #909399;">
		          暂无数据
		        </el-option>
		        
		        <!-- 加载中选项 -->
		        <el-option v-if="relationLoading" disabled style="text-align: center; color: #909399;">
		          <i class="el-icon-loading"></i> 加载中...
		        </el-option>
		      </el-select>
		    </el-form-item>
		    
		    <el-form-item label="备注" prop="remark">
		      <el-input v-model="relationForm.remark" type="textarea" :rows="3" placeholder="请输入备注信息"></el-input>
		    </el-form-item>
		  </el-form>
		  <span slot="footer" class="dialog-footer">
		    <el-button size="mini" @click="addRelationDialogVisible = false">取 消</el-button>
		    <el-button size="mini" type="primary" @click="confirmAddRelation">确 定</el-button>
		  </span>
		</el-dialog>
      </div>
      <!-- 过敏原选择模态框 -->
      <div class="getAise">
        <el-dialog
          v-dialogDrag
          :title="allergyDialogTitle"
          :visible.sync="aisedialogVisible"
          width="40%"
          top="12px"
          :before-close="aiseHandleClose"
        >
          <div class="aiseTable">
            <div class="aiseTable-header">
              <span>关键字：</span>
              <el-input v-model="searchInput" placeholder="请输入内容" size="mini"></el-input>
              <!-- 移除顶部的选择按钮 -->
              <span>数据来源：</span>
              <el-select v-model="dataFrom" placeholder="请选择" size="mini" @change="dataFromHandle">
                  <el-option
                    v-for="item in dataFromOptions"
                    :key="item.id"
                    :label="item.label"
                    :value="item.id">
                  </el-option>
              </el-select>
            </div>
            <div class="aiseTable-main">
              <!-- 表格双击选择过敏原数据 -->
              <div class="table">
                <el-table 
                  :data="filteredAiseData"
                  border 
                  height="188" 
                  highlight-current-row 
                  @current-change="handleCurrentChange" 
                  @row-dblclick="selectRows"
                >
                  <el-table-column fixed="left" label="行号" type="index" width="50"></el-table-column>
                  <el-table-column label="编码" prop="code" width="100"></el-table-column>
                  <el-table-column label="过敏原名称" width="120">
                    <template slot-scope="scope">
                      <span>{{ scope.row.name || '未知' }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="过敏原类别" width="100">
                    <template slot-scope="scope">
                      <span>{{ aiseMap[scope.row.type] || '未知' }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="数据来源" width="100">
                    <template slot-scope="scope">
                      <span>{{ dataFromMap[scope.row.dataSource] || '未知' }}</span>
                    </template>
                  </el-table-column>
                  <!-- 添加选择按钮列 -->
                  <el-table-column fixed="right" label="操作" width="80" align="center">
                    <template slot-scope="scope">
                      <el-button
                        type="primary"
                        size="mini"
                        @click="selectSingleRow(scope.row)"
                      >选择</el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
              <!-- 已选择过敏原数据 -->
              <div class="tableChosed">
                <span>已选过敏原：</span>
                <el-table :data="tempAiseChosedData" border height="188" highlight-current-row>
                  <el-table-column fixed="left" label="行号" type="index" width="50"></el-table-column>
                  <el-table-column label="编码" prop="code" width="50"></el-table-column>
                  <el-table-column label="过敏原名称" width="120">
                    <template slot-scope="scope">
                      <span>{{ scope.row.name || '未知' }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="过敏原类别" width="88">
                    <template slot-scope="scope">
                      <span>{{ aiseMap[scope.row.type] || '未知' }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="数据来源" width="88">
                    <template slot-scope="scope">
                      <span>{{ dataFromMap[scope.row.dataSource] || '未知' }}</span>
                    </template>
                  </el-table-column>
                  <!-- 操作列 -->
                  <el-table-column fixed="right" label="操作" width="60" align="center">
                    <template slot-scope="scope">
                      <el-button
                        type="danger"
                        size="mini"
                        icon="el-icon-delete"
                        @click="removeTempAllergy(scope.$index)"
                      ></el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </div>
          </div>
          <span slot="footer" class="dialog-footer">
            <el-button type="primary" size="mini" @click="aiseDialogConfirm">选好了</el-button>
          </span>
        </el-dialog>
      </div>
      <!-- 底部按钮区域 -->
      <span slot="footer" class="dialog-footer">
        <!-- 新增模式 -->
        <template v-if="mode === 'add'">
          <el-button size="mini" @click="handleCancel">关 闭</el-button>
          <el-button size="mini" type="primary" @click="addSubmit" :loading="submitting">确认创建</el-button>
        </template>
        
        <!-- 编辑模式 -->
        <template v-else-if="mode === 'edit'">
          <el-button size="mini" @click="handleCancel">关 闭</el-button>
          <el-button size="mini" type="primary" @click="editSubmit" :loading="submitting">保存修改</el-button>
        </template>
        
        <!-- 查看模式 -->
        <template v-else-if="mode === 'view'">
          <el-button size="mini" @click="handleCancel">关 闭</el-button>
        </template>
      </span>
    </el-dialog>
</template>

<script>
	// 导入工具和接口
	import AddType from './AddType.js';
	import AccMainType from './AddTypeMain.js';
	import addForm from './addForm.js';
	import { getLunar } from 'chinese-lunar-calendar';
	import { getdict, aiseList, addDocphr, aiseDetails, updateDocphr, addPhrAlg, deleteDocphr, docphrList, addRelationPhr, deleteRelation, listRelation } from "@/api/reservation/healthrecords.js";
	import { getArea } from "@/api/user.js";
	
	export default {
		props: {
			parentMethod: Function,
			clinicName: {
				type: String,
				default: '诊所'
			}
		},
		computed: {
			getZodiacIcon() {
				return this.zodiacIconMap[this.Zodiac] || 'el-icon-more';
			},
			// 对话框标题
			dialogTitle() {
				const name = this.addForm.name || '未知人员';
				switch (this.mode) {
					case 'add':
						return `为【${this.clinicName}】新建健康人员档案`;
					case 'edit':
						return `编辑 - 人员【${name}】- 的健康档案信息`;
					case 'view':
						return `查看 - 人员【${name}】- 的健康档案信息`;
					default:
						return '健康档案';
				}
			},
			// 过敏原对话框标题
			allergyDialogTitle() {
				if (this.isEditAllergyMode && this.currentEditAllergyName) {
					return `修改【${this.currentEditAllergyName}】的过敏原信息`;
				}
				return '过敏原选择';
			},
			// 关联对话框标题
			relationDialogTitle() {
				if (this.isReRelationMode && this.reRelationRow && this.reRelationRow.name) {
					return `为【${this.reRelationRow.name}】重新关联人员`;
				}
				return '添加关联';
			},
			// 过滤过敏原数据
			filteredAiseData() {
				if (!this.searchInput) {
					return this.aiseData;
				}
				const search = this.searchInput.toLowerCase();
				return this.aiseData.filter(data => 
					(data.name && data.name.toLowerCase().includes(search)) ||
					(data.code && data.code.toLowerCase().includes(search))
				);
			},
			// 过滤关联人员选项，不再排除自己，全部显示出来
			filteredRelationOptions() {
			return this.relationOptions; // 不再过滤，直接返回所有选项
		  },
		},
		data() {
			return {
				// 模式控制
				mode: 'add', // 'add' | 'edit' | 'view'
				submitting: false,
				
				// 过敏原选择相关
				isEditAllergyMode: false, // 是否是编辑过敏原模式
				currentEditAllergyIndex: -1, // 当前编辑的过敏原索引
				currentEditAllergyName: '', // 当前编辑的过敏原名称
				tempAiseChosedData: [], // 临时存储已选过敏原数据
				
				// 新增：添加关联对话框
				addRelationDialogVisible: false,
				relationForm: {
				  relationId: null, // 修改这里：从 '' 改为 null
				  remark: ''
				},
				// 地址级联选择器相关
				addressOptions: {
				  province: [], // 省份数据
				  city: new Map(), // 城市数据，按省份分组
				  district: new Map(), // 区县数据，按城市分组
				  town: new Map(), // 乡镇数据，按区县分组
				  village: new Map() // 村社区数据，按乡镇分组
				},
				addressLoading: false, // 地址加载状态
				
				// 联系地址相关
				contactAddressSelected: [], // 级联选择器选中的地址编码数组
				contactAddressDetail: '',    // 详细地址（门牌号）
				
				// 删除原有的四个地址字段映射，添加联系地址映射
				// 地址字段映射
				addressFieldMap: {
				  contactAdd: { code: 'conerAddCode', name: 'conerAddName', label: '联系地址' },
				},
				relationData: [],
				// 重新关联相关
				isReRelationMode: false, // 是否是重新关联模式
				reRelationRow: null, // 重新关联的行数据
				
				// 关联信息
				relatedInfo: {
					visitCount: 0,
					prescriptionCount: 0,
					examCount: 0,
					healthLevel: '良好',
					lastUpdateTime: '',
					remark: ''
				},
				
				// 字符串
				areaCode: '',
				searchInput: '',
				dataFrom: '',
				activeName: 'first',
				condtion: 'area_p_code',
				getLunarDay: '',
				Zodiac: '',
				
				// 缓存
				searchCache: new Map(),
				searchLoading: false,
				
				// 数字
				idx: 0,
				areaLevel: 1,
				
				// 布尔值
				addBtn: false,
				editBtn: false,
				dialogVisible: false,
				aisedialogVisible: false,
				isChecked: false,
				// 关联信息相关
				relationOptions: [], // 关联人员下拉选项
				relationLoading: false, // 关联人员加载状态
				isNormalData: true, // 正常数据复选框状态
				showRelationHeader: false, // 控制表头是否显示
				showRelationTooltip: false, // 控制关联选项提示框的显示  <-- 新增
				searchTimer: null, // 搜索定时器
				
				// 数组
				formType: [],
				formMainType: [],
				areaII: [],
				aiseData: [],
				currentTable: [],
				aiseChosedData: [],
				sexOption: [
					{ id: 1, label: '男', value: 1 },
					{ id: 2, label: '女', value: 2 },
					// { id: 9, label: '未说明的性别', value: 9 },
					// { id: 0, label: '未知的性别', value: 0 },
				],
				statusOption: [
					{ id: 1, label: '可用', value: '可用' },
					{ id: 0, label: '锁定', value: '锁定' }
				],
				dataFromOptions: [
					{ id: 1, label: '手工选择' },
					{ id: 2, label: '皮试结果' }
				],
				createTypeOption: [
					{ id: 1, label: '线下窗口' },
					{ id: 2, label: '网络平台' },
					{ id: 3, label: '微信小程序' },
					{ id: 4, label: '线下推广' }
				],
				marryiedOptions: [],
				natyOptions: [],
				edulOptions: [],
				ntlyOptions: [],
				jobOptions: [],
				ABOOptions: [],
				RHOptions: [],
				certypeOptions: [],
				briOption: [],
				workOption: [],
				nativeOption: [],
				bookOption: [],
				conOption: [],
				rltsEntitiesOptions: [],
				ssqOptions: [],
				
				// 过敏原名称映射
				aiseNameMap: {},
				
				// 对象
				addForm: {},
				addMainForm: {},
				saved: {},
				
				// 日期选择器
				pickerOptions: {
					shortcuts: [
						{ text: '今天', onClick(picker) { picker.$emit('pick', new Date()); } },
						{ text: '昨天', onClick(picker) { 
							const date = new Date();
							date.setTime(date.getTime() - 3600 * 1000 * 24);
							picker.$emit('pick', date);
						}},
						{ text: '一周前', onClick(picker) { 
							const date = new Date();
							date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
							picker.$emit('pick', date);
						}},
						{ text: '最近一个月', onClick(picker) { 
							const date = new Date();
							date.setTime(date.getTime() - 3600 * 1000 * 24 * 30);
							picker.$emit('pick', date);
						}},
						{ text: '最近三个月', onClick(picker) { 
							const date = new Date();
							date.setTime(date.getTime() - 3600 * 1000 * 24 * 90);
							picker.$emit('pick', date);
						}},
						{ text: '半年前', onClick(picker) { 
							const date = new Date();
							date.setTime(date.getTime() - 3600 * 1000 * 24 * 180);
							picker.$emit('pick', date);
						}},
						{ text: '去年', onClick(picker) { 
							const date = new Date();
							date.setTime(date.getTime() - 3600 * 1000 * 24 * 360);
							picker.$emit('pick', date);
						}}
					]
				},
				
				// 地址数据
				addressData: {
					brdyAddCode: {
						value: [],
						options: [],
						loaded: false
					},
					emprAddCode: {
						value: [],
						options: [],
						loaded: false
					},
					naplAddCode: {
						value: [],
						options: [],
						loaded: false
					},
					restAddCode: {
						value: [],
						options: [],
						loaded: false
					}
				},
				
				// 级联选择器配置
				caserProps: {
				  lazy: true,
				  lazyLoad: this.lazyLoadArea,
				  filterable: true,
				  checkStrictly: false,
				  emitPath: true,
				  // 恢复使用areaCode作为value
				  value: 'value',  
				  label: 'label',
				  leaf: 'leaf',
				  multiple: false
				},
				
				loadedNodes: {},
				isRootLoaded: false,
				addressTypes: ['brdyAdd', 'emprAdd', 'naplAdd', 'restAdd'],
				addressFields: {
					brdyAdd: { code: 'brdyAddCode', name: 'brdyAddName' },
					emprAdd: { code: 'emprAddCode', name: 'emprAddName' },
					naplAdd: { code: 'naplAddCode', name: 'naplAddName' },
					restAdd: { code: 'restAddCode', name: 'restAddName' }
				},
				
				searchText: '',
				brdyAddPath: [],
				emprAddPath: [],
				naplAddPath: [],
				restAddPath: [],
				brdyAddOptions: [],
				emprAddOptions: [],
				naplAddOptions: [],
				restAddOptions: [],
				
				zodiacIconMap: {
					'鼠': 'icon-mouse',
					'牛': 'icon-nb',
					'虎': 'icon-tiger',
					'兔': 'icon-rabbit',
					'龙': 'icon-dragon',
					'蛇': 'icon-snake',
					'马': 'icon-horse',
					'羊': 'icon-sheep',
					'猴': 'icon-monkey',
					'鸡': 'icon-rooster',
					'狗': 'icon-dog',
					'猪': 'icon-pig'
				},
				
				// 过敏原类别映射
				aiseMap: {
					1: '药品',
					2: '其他'
				},
				
				// 数据来源映射
				dataFromMap: {
					1: '手工选择',
					2: '皮试结果'
				},
				
				// 性别映射
				sexTextMap: { // 性别映射
				  0: '未知',
				  1: '男',
				  2: '女',
				  9: '未说明'
				},
				
				// 表单验证规则
				addRules: {
					certno: [{ 
						required: true,
						pattern: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/,
						message: '身份证号码格式有误！',
						trigger: 'blur' 
					}],
					name: [{ 
						required: true,
						message: '姓名不能为空哦',
						trigger: 'blur' 
					}],
					ntlyId: [{ 
						required: true,
						message: '国籍不能为空哦',
						trigger: 'change' 
					}],
					tel: [{ 
						required: true,
						pattern: /^1[3-9]\d{9}$/,
						message: '电话号码格式有误!',
						trigger: 'blur' 
					}],
					conerTel: [{ 
						required: false,
						pattern: /^1[3-9]\d{9}$/,
						message: '不想填就不填哈!',
						trigger: 'blur' 
					}]
				}
			};
		},
		mounted() {
			this.getForm();
			this.getAise();
		},
		methods: {
			// 获取排序后的表单字段
			getOrderedFormFields() {
				if (!this.formType || this.formType.length === 0) {
					return [];
				}
				
				// 定义优先级顺序
				const priorityOrder = ['name', 'sex', 'thrNot', 'certno'];
				
				// 找到优先字段
				const priorityFields = [];
				const otherFields = [];
				
				this.formType.forEach(field => {
					if (field.modelValue && priorityOrder.includes(field.modelValue)) {
						// 按照priorityOrder的顺序插入
						const index = priorityOrder.indexOf(field.modelValue);
						priorityFields[index] = field;
					} else {
						otherFields.push(field);
					}
				});
				
				// 过滤掉空值，合并数组
				const result = priorityFields.filter(Boolean).concat(otherFields);
				return result;
			},
			
			// 打开对话框
			async open(rowData, mode) {
			  this.mode = mode || 'add';
			  this.dialogVisible = true;
			  this.activeName = 'first'; // 默认显示第一个标签页
			  
			  // 重置表单
			  this.resetForm();
			  
			  // 加载字典数据
			  await this.getDic();
			  
			  // 根据不同模式处理数据
			  if (mode === 'add') {
			    // 新增模式
			    this.addForm = { ...addForm.map(v => v)[0] };
			    this.addBtn = false;
			    this.editBtn = false;
			    
			    // 设置默认值
			    const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
			    this.addForm.operator = userInfo.userName || '';
			    this.addForm.operatingTime = new Date().toLocaleString();
			    
			    // 初始化关联信息
			    this.relatedInfo = {
			      visitCount: 0,
			      prescriptionCount: 0,
			      examCount: 0,
			      healthLevel: '未评估',
			      lastUpdateTime: new Date().toLocaleString(),
			      remark: ''
			    };
			    
			  } else if (mode === 'edit' || mode === 'view') {
			    // 编辑或查看模式
			    if (rowData && rowData.id) {
			      try {
			        // 获取详情数据
			        const res = await aiseDetails({ id: rowData.id });
			        console.log('获取详情数据:', res);
			        
			        if (res.code === 200 && res.data) {
			          // 合并数据
			          this.addForm = { ...addForm.map(v => v)[0], ...res.data };
			          this.addForm.id = rowData.id;
			          
			          // 处理联系地址字段回显 - 不再调用getArea接口
			          this.processContactAddressForEdit(res.data);
			          
			          // 处理身份证号码脱敏显示
			          if (this.addForm.certno) {
			            const idCard = this.addForm.certno;
			            if (idCard.length > 10) {
			              const firstPart = idCard.substring(0, 6);
			              const lastPart = idCard.substring(idCard.length - 4);
			              this.addForm.certnoDisplay = `${firstPart}****${lastPart}`;
			            }
			          }
			          
			          // 设置按钮状态
			          this.addBtn = (mode === 'edit');
			          this.editBtn = (mode === 'edit');
			          
			          // 处理过敏原数据
			          if (res.data.rhrAlgs && Array.isArray(res.data.rhrAlgs)) {
			            // 等待aiseData加载完成
			            await this.getAise();
			            
			            this.aiseChosedData = res.data.rhrAlgs.map(item => {
			              const aiseName = this.getAiseNameById(item.aiseId);
			              return {
			                ...item,
			                name: aiseName
			              };
			            });
			          } else {
			            this.aiseChosedData = [];
			          }
			          
			          console.log('过敏原数据:', this.aiseChosedData);
			          
			          // 加载关联信息
			          this.loadRelatedInfo(rowData.id);
			          
			          // 如果当前是第三个标签页，加载关联数据
			          if (this.activeName === 'third') {
			            this.loadRelationData(rowData.id);
			          }
			        } else {
			          this.$message.error(res.message || '获取详情失败');
			        }
			      } catch (error) {
			        console.error('获取详情失败:', error);
			        this.$message.error('加载数据失败');
			      }
			    }
			  }
			  
			  // 触发模式变化事件
			  this.$emit('mode-changed', this.mode);
			},
			
			// 处理联系地址字段
			processContactAddress(data) {
			  console.log('处理联系地址回显，数据:', data);
			  
			  // 设置联系地址编码
			  if (data.conerAddCode) {
			    this.addForm.conerAddCode = data.conerAddCode;
			    
			    // 将编码设置为级联选择器的选中值
			    this.contactAddressSelected = [data.conerAddCode];
			    
			    console.log('设置级联选择器选中值:', this.contactAddressSelected);
			  }
			  
			  // 设置联系地址名称
			  if (data.conerAddName) {
			    this.addForm.conerAddName = data.conerAddName;
			    this.contactAddressDetail = data.conerAddName;
			    
			    console.log('设置详细地址:', this.contactAddressDetail);
			  }
			},
			
			// 根据aiseId获取过敏原名称
			getAiseNameById(aiseId) {
				// 从本地aiseData中查找
				const aiseItem = this.aiseData.find(item => item.id === aiseId);
				return aiseItem ? aiseItem.name : `过敏原${aiseId}`;
			},
			
			// 获取过敏描述文本
			getAlgsDeseText(row) {
				// 如果已经有algsDese字段，直接返回
				if (row.algsDese && row.algsDese.trim()) {
					return row.algsDese;
				}
				
				// 获取过敏原名称
				const aiseName = this.getAiseNameById(row.aiseId);
				
				// 根据type和dataSource生成过敏描述
				if (row.type === 1) {
					// 药品类型
					if (row.dataSource === 2) {
						// 皮试结果
						return `${aiseName}皮试阳性`;
					} else {
						// 手工选择
						return `${aiseName}过敏`;
					}
				} else {
					// 其他类型
					return `${aiseName}过敏`;
				}
			},
			
			// 加载关联信息
			loadRelatedInfo(id) {
				// 模拟加载关联信息
				this.relatedInfo = {
					visitCount: Math.floor(Math.random() * 10),
					prescriptionCount: Math.floor(Math.random() * 20),
					examCount: Math.floor(Math.random() * 5),
					healthLevel: ['良好', '一般', '注意', '异常'][Math.floor(Math.random() * 4)],
					lastUpdateTime: new Date().toLocaleString(),
					remark: '这是关联信息的备注内容，可以根据实际情况进行调整。'
				};
			},
			
			// 加载关联数据
			async loadRelationData(id) {
				if (!id) return;
				
				try {
					console.log('加载关联数据，ID:', id);
					// 调用接口获取关联数据
					const res = await listRelation({ id: id });
					console.log('关联数据接口返回:', res);
					
					if (res.code === 200 && res.data) {
						this.relationData = res.data.map(item => ({
							...item,
							createTime: item.createTime || new Date().toLocaleString(),
							creator: item.creator || '系统'
						}));
					} else {
						// 如果接口没有数据，使用模拟数据
						this.relationData = this.getMockRelationData();
					}
				} catch (error) {
					console.error('加载关联数据失败:', error);
					// 使用模拟数据
					this.relationData = this.getMockRelationData();
				}
			},
			
			// 模拟关联数据
			getMockRelationData() {
				return [
					{
						id: 1,
						relationType: '就诊记录',
						content: '2023年10月15日门诊就诊',
						createTime: '2023-10-15 14:30:00',
						creator: '张医生',
						remark: '普通感冒'
					},
					{
						id: 2,
						relationType: '处方记录',
						content: '头孢克肟胶囊 0.1g*12粒',
						createTime: '2023-10-15 15:20:00',
						creator: '张医生',
						remark: '每日两次，每次一粒'
					},
					{
						id: 3,
						relationType: '检验检查',
						content: '血常规检查',
						createTime: '2023-10-15 16:10:00',
						creator: '检验科',
						remark: '白细胞计数偏高'
					}
				];
			},
			
			// 标签页切换事件
			handleTabClick(tab) {
				console.log('切换到标签页:', tab.name);
				if (tab.name === 'third' && this.addForm.id) {
					// 切换到关联信息标签页，加载关联数据
					this.loadRelationData(this.addForm.id);
				}
			},
			
			// 打开添加关联对话框
			openAddRelationDialog() {
			  if (!this.addForm.id) {
			    this.$message.warning('请先保存基本信息');
			    return;
			  }
			  
			  this.relationForm = {
			    relationId: '',
			    remark: ''
			  };
			  this.isNormalData = true;
			  this.relationOptions = [];
			  this.isReRelationMode = false;
			  this.reRelationRow = null;
			  
			  this.addRelationDialogVisible = true;
			  
			  // 对话框打开后自动加载一次数据
			  this.$nextTick(() => {
			    this.loadRelationOptions();
			  });
			},
			
			// 重新关联
			handleReRelation(row) {
			  if (!this.addForm.id) {
			    this.$message.warning('请先保存基本信息');
			    return;
			  }
			  
			  this.isReRelationMode = true;
			  this.reRelationRow = row;
			  this.relationForm = {
			    relationId: '',
			    remark: row.remark || ''
			  };
			  this.isNormalData = true;
			  this.relationOptions = [];
			  
			  this.addRelationDialogVisible = true;
			  
			  // 对话框打开后自动加载一次数据
			  this.$nextTick(() => {
			    this.loadRelationOptions();
			  });
			},
			
			// 关闭添加关联对话框
			handleRelationDialogClose(done) {
				this.$confirm('确认关闭？', '提示', {
					type: 'warning'
				}).then(() => {
					this.addRelationDialogVisible = false;
					this.isReRelationMode = false;
					this.reRelationRow = null;
					if (done) done();
				}).catch(() => {});
			},
			
			// 重置表单
			resetForm() {
			  this.addForm = {};
			  this.addMainForm = {};
			  this.isChecked = false;
			  this.Zodiac = '';
			  this.aiseChosedData = [];
			  this.relationData = [];
			  this.tempAiseChosedData = [];
			  this.relatedInfo = {
			    visitCount: 0,
			    prescriptionCount: 0,
			    examCount: 0,
			    healthLevel: '未评估',
			    lastUpdateTime: '',
			    remark: ''
			  };
			  this.isReRelationMode = false;
			  this.reRelationRow = null;
			  
			  // 重置联系地址相关字段
			  this.contactAddressSelected = [];
			  this.contactAddressDetail = '';
			  
			  // 清空验证
			  if (this.$refs.addForm) {
			    this.$refs.addForm.clearValidate();
			  }
			},
			
			// 获取完整地址路径
			async getFullAddressPath(areaCode) {
			  if (!areaCode) {
			    return [];
			  }
			  
			  try {
			    // 这里需要根据实际业务逻辑获取完整的地址路径
			    // 由于我们的接口限制，暂时只返回当前编码
			    // 实际项目中可能需要调用接口获取完整的路径
			    return [areaCode];
			  } catch (error) {
			    console.error('获取完整地址路径失败:', error);
			    return [areaCode];
			  }
			},
			
			// 详细地址变更处理
			handleAddressDetailChange(value) {
			  this.contactAddressDetail = value || '';
			  
			  // 设置联系地址名称字段
			  this.addForm.conerAddName = value || '';
			  
			  console.log('设置联系地址名称:', {
			    conerAddName: this.addForm.conerAddName,
			    contactAddressDetail: this.contactAddressDetail
			  });
			},
			
			// 获取完整的联系地址名称
			getContactAddressFullName(selectedNodes) {
			  if (!selectedNodes || selectedNodes.length === 0) {
			    return '';
			  }
			  
			  // 从节点中提取地址名称
			  return selectedNodes.map(node => {
			    if (typeof node === 'object') {
			      return node.label || node.areaName || '';
			    }
			    return node;
			  }).filter(name => name).join('');
			},
			
			// 关闭对话框
			handleClose(done) {
				this.$confirm('确认关闭？当前编辑的内容将不会保存。', '提示', {
					type: 'warning',
					confirmButtonText: '确定',
					cancelButtonText: '取消'
				}).then(() => {
					this.dialogVisible = false;
					this.resetForm();
					if (done) done();
				}).catch(() => {});
			},
			
			// 取消按钮
			handleCancel() {
				this.dialogVisible = false;
				this.resetForm();
			},
			
			// 获取表单配置
			getForm() {
				this.addForm = addForm.map(v => v)[0];
				this.formType = AddType.map(v => v);
				this.formMainType = AccMainType.map(v => v);
			},
			
			// 懒加载地址数据
			async lazyLoadArea(node, resolve) {
			  try {
			    let params = {
			      areaCode: '',
			      areaLevel: 1,
			      condtion: ''
			    };
			    
			    if (node.level === 0) {
			      // 第一级：省份
			      params = {
			        areaCode: '',
			        areaLevel: 1,
			        condtion: ''
			      };
			    } else {
			      // 根据父节点层级设置参数
			      const parentNode = node;
			      
			      if (parentNode.data && parentNode.data.areaCode) {
			        params.areaCode = parentNode.data.areaCode;
			      } else {
			        params.areaCode = '';
			      }
			      
			      // 根据当前层级设置参数
			      const currentLevel = parentNode.level + 1;
			      
			      switch (currentLevel) {
			        case 2:
			          // 加载市
			          params.areaLevel = 2;
			          params.condtion = 'area_p_code';
			          break;
			        case 3:
			          // 加载区县
			          params.areaLevel = 3;
			          params.condtion = 'area_c_code';
			          break;
			        case 4:
			          // 加载乡镇
			          params.areaLevel = 4;
			          params.condtion = 'area_d_code';
			          break;
			        case 5:
			          // 加载村社区
			          params.areaLevel = 5;
			          params.condtion = 'area_t_code';
			          break;
			        default:
			          params.areaLevel = 1;
			          params.condtion = '';
			      }
			    }
			    
			    const res = await getArea(params);
			    
			    if (res.code === 200 && res.data && Array.isArray(res.data)) {
			      const nodes = res.data.map(item => {
			        return {
			          // 恢复使用areaCode作为value
			          value: item.areaCode, 
			          label: item.areaName || '',
			          areaCode: item.areaCode || '',
			          areaName: item.areaName || '',
			          fullNameRegion: item.fullNameRegion || '',
			          leaf: params.areaLevel >= 5,
			          hasChildren: params.areaLevel < 5
			        };
			      });
			      
			      console.log(`加载到${nodes.length}条地址数据`);
			      resolve(nodes);
			    } else {
			      console.warn('地址接口返回数据格式不正确:', res);
			      resolve([]);
			    }
			  } catch (error) {
			    console.error('加载地址数据失败:', error);
			    this.$message.error('加载地址数据失败');
			    resolve([]);
			  }
			},
			
			// 构建完整的地址名称区域
			buildFullNameRegion(parentNode, currentItem) {
			  let fullPath = '';
			  
			  // 如果有父节点，构建父节点路径
			  if (parentNode && parentNode.data) {
			    if (parentNode.data.fullNameRegion) {
			      fullPath = parentNode.data.fullNameRegion + '/' + currentItem.areaName;
			    } else if (parentNode.data.areaName) {
			      fullPath = parentNode.data.areaName + '/' + currentItem.areaName;
			    } else {
			      fullPath = currentItem.areaName;
			    }
			  } else {
			    fullPath = currentItem.areaName;
			  }
			  
			  return fullPath;
			},
			
			// 地址变更处理
			handleAddressChange(addressType, value) {
			  if (value) {
			    // 获取对应的名称字段
			    const nameField = this.addressFieldMap[addressType].name;
			    
			    // 这里我们需要获取完整的地址路径
			    // 由于级联选择器返回的是选中的节点数组
			    // 我们可以从节点数组中提取完整的地址名称
			    if (Array.isArray(value) && value.length > 0) {
			      // 获取完整的地址路径
			      const fullAddress = this.getFullAddressName(value);
			      this.addForm[nameField] = fullAddress;
			    } else {
			      // 如果没有值，清空地址名称
			      this.addForm[nameField] = '';
			    }
			  } else {
			    // 清空地址名称
			    const nameField = this.addressFieldMap[addressType].name;
			    this.addForm[nameField] = '';
			  }
			},
			
			// 获取完整的地址名称
			getFullAddressName(selectedNodes) {
			  if (!selectedNodes || selectedNodes.length === 0) {
			    return '';
			  }
			  
			  // 从节点中提取地址名称
			  return selectedNodes.map(node => {
			    if (typeof node === 'object') {
			      return node.areaName || node.label || '';
			    }
			    return node;
			  }).filter(name => name && name.trim()).join('/');
			},
			
			// 获取字典数据
			async getDic() {
				try {
					let resDict = await getdict();
					if (resDict.code === 200 && resDict.data) {
						// 婚姻状况
						this.marryiedOptions = (resDict.data.mrgStateEntities || []).map(v => ({ label: v.name, ...v }));
						// 国籍
						this.ntlyOptions = (resDict.data.country || []).map(v => ({ label: v.name, ...v }));
						// 民族
						this.natyOptions = (resDict.data.natyEntities || []).map(v => ({ label: v.name, ...v }));
						// 学历
						this.edulOptions = (resDict.data.edulBacdEntities || []).map(v => ({ label: v.name, ...v }));
						// 职业
						this.jobOptions = (resDict.data.jobEntities || []).map(v => ({ label: v.name, ...v }));
						// ABO血型
						this.ABOOptions = (resDict.data.aboTypeEntities || []).map(v => ({ label: v.name, ...v })).filter(item => item.id !== 5 && item.id !== 6);
						// RH血型
						this.RHOptions = (resDict.data.aboTypeEntities || []).map(v => ({ label: v.name, ...v })).filter(item => item.id === 5 || item.id === 6);
						// 联系人关系
						this.rltsEntitiesOptions = (resDict.data.rltsEntities || []).map(v => ({ label: v.name, ...v }));
						// 证件类型
						this.certypeOptions = (resDict.data.certypeEntities || []).map(v => ({ label: v.name, ...v }));
					}
				} catch (error) {
					console.error('获取字典数据失败:', error);
				}
			},
			
			// 其他方法
			validateAndCompute(v, i) {
			  if (v.modelValue === 'certno') {  // 身份证字段
			    const idCard = this.addForm.certno;
			    if (idCard && (idCard.length === 15 || idCard.length === 18)) {
			      this.computeInfoFromIdCard(idCard);
			    }
			  }
			},
			
			// 计算性别、出生日期、农历、生肖
			computeInfoFromIdCard(idCard) {
			  if (!idCard || (idCard.length !== 15 && idCard.length !== 18)) return;
			
			  let birthYear, birthMonth, birthDay, genderCode;
			
			  if (idCard.length === 15) {
			    // 15位身份证：年份前两位补19
			    birthYear = parseInt('19' + idCard.substring(6, 8));
			    birthMonth = parseInt(idCard.substring(8, 10));
			    birthDay = parseInt(idCard.substring(10, 12));
			    genderCode = idCard.charAt(14);
			  } else {
			    // 18位身份证
			    birthYear = parseInt(idCard.substring(6, 10));
			    birthMonth = parseInt(idCard.substring(10, 12));
			    birthDay = parseInt(idCard.substring(12, 14));
			    genderCode = idCard.charAt(16);
			  }
			
			  // 性别：奇数为男(1)，偶数为女(2)
			  const gender = parseInt(genderCode) % 2 === 1 ? 1 : 2;
			  this.$set(this.addForm, 'sex', gender);
			
			  // 出生日期（格式 YYYY-MM-DD）
			  const birthDate = `${birthYear}-${String(birthMonth).padStart(2, '0')}-${String(birthDay).padStart(2, '0')}`;
			  this.$set(this.addForm, 'brdy', birthDate);
			
			  // 计算农历和生肖
			  try {
			    const lunar = getLunar(birthYear, birthMonth, birthDay);
			    if (lunar) {
			      this.$set(this.addForm, 'lunrBrdy', lunar.dateStr);
			      this.Zodiac = lunar.zodiac;
			    }
			  } catch (error) {
			    console.warn('农历计算失败:', error);
			  }
			
			  // 计算年龄（精确到周岁）
			  this.computeAgeFromBirthDate(birthYear, birthMonth, birthDay);
			},
			
			// 根据出生日期计算周岁年龄
			computeAgeFromBirthDate(birthYear, birthMonth, birthDay) {
			  const today = new Date();
			  const birthDate = new Date(birthYear, birthMonth - 1, birthDay);
			  let age = today.getFullYear() - birthYear;
			  const monthDiff = today.getMonth() - (birthMonth - 1);
			  const dayDiff = today.getDate() - birthDay;
			  if (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)) {
			    age--;
			  }
			  this.$set(this.addForm, 'age', age >= 0 ? age : 0);
			},
			
			// 原 computeAgeFromIdCard 可删除，或者在身份证解析时直接调用 computeAgeFromBirthDate
			computeAgeFromIdCard(idCard) {
			  // 此方法已过时，由 computeAgeFromBirthDate 替代
			  if (!idCard) return;
			  let birthYear;
			  if (idCard.length === 15) {
			    birthYear = parseInt('19' + idCard.substring(6, 8));
			  } else if (idCard.length === 18) {
			    birthYear = parseInt(idCard.substring(6, 10));
			  } else {
			    return;
			  }
			  const currentYear = new Date().getFullYear();
			  this.$set(this.addForm, 'age', currentYear - birthYear);
			},
			
			toggleYesNo(value) {
				this.addForm.thrNot = value ? 1 : 0;
				if (this.addForm.thrNot === 1) {
					this.saved = {
						name: this.addForm.name,
						certno: this.addForm.certno,
						tel: this.addForm.tel
					};
					this.addForm.name = '';
					this.addForm.certno = '';
					this.addForm.tel = '';
				} else {
					for (let key in this.saved) {
						if (this.addForm.hasOwnProperty(key)) {
							this.addForm[key] = this.saved[key];
						}
					}
				}
			},
			
			// 新增提交
			async addSubmit() {
			  this.submitting = true;
			  try {
			    await this.$refs.addForm.validate();
			    
			    // 确保地址字段正确赋值
			    this.ensureContactAddressFields();
			    
			    console.log('新增提交，conerAddCode参数（areaCode）:', this.addForm.conerAddCode);
			    
			    // 准备提交数据
			    const submitData = {
			      ...this.addForm,
			      rhrAlgs: this.aiseChosedData.map(item => ({
			        aiseId: item.aiseId || item.id,
			        algsDese: this.getAlgsDeseText(item),
			        dataSource: item.dataSource || 1,
			        type: item.type || 2
			      }))
			    };
			    
			    console.log('新增提交数据:');
			    console.log('conerAddCode参数（areaCode）:', submitData.conerAddCode);
			    
			    const res = await addDocphr(submitData);
			    
			    if (res.code === 200) {
			      this.$message.success('创建成功！');
			      this.dialogVisible = false;
			      this.resetForm();
			      
			      // 调用父组件刷新数据
			      if (this.parentMethod) {
			        this.parentMethod();
			      }
			    } else {
			      this.$message.error(res.message || '创建失败');
			    }
			  } catch (error) {
			    console.error('表单验证失败:', error);
			    if (!error.response) {
			      this.$message.error('请检查表单填写是否正确');
			    }
			  } finally {
			    this.submitting = false;
			  }
			},
			
			// 确保联系地址字段正确赋值
			ensureContactAddressFields() {
			  console.log('确保联系地址字段正确赋值，当前状态:', {
			    conerAddCode: this.addForm.conerAddCode,
			    conerAddName: this.addForm.conerAddName,
			    contactAddressSelected: this.contactAddressSelected,
			    contactAddressDetail: this.contactAddressDetail
			  });
			  
			  // 如果级联选择器有选中值，但conerAddCode为空，直接取最后一个areaCode
			  if (this.contactAddressSelected && this.contactAddressSelected.length > 0 && !this.addForm.conerAddCode) {
			    this.addForm.conerAddCode = this.contactAddressSelected[this.contactAddressSelected.length - 1] || '';
			  }
			  
			  // 如果有输入框值但名称字段为空，则设置
			  if (this.contactAddressDetail && !this.addForm.conerAddName) {
			    this.addForm.conerAddName = this.contactAddressDetail;
			  }
			  
			  console.log('赋值后:', {
			    conerAddCode: this.addForm.conerAddCode,
			    conerAddName: this.addForm.conerAddName
			  });
			},
			
			// 鼠标移入选项，显示工具提示（如果需要的话）
			  handleOptionMouseEnter(item) {
			    // 这里可以设置一些状态，例如高亮当前行
			    // 如果需要根据条件显示 tooltip，可以在这里设置 showRelationTooltip
			    // 例如： if (item.id === this.addForm.id) { this.showRelationTooltip = true; }
			  },
			  // 鼠标移出选项，隐藏工具提示
			  handleOptionMouseLeave() {
			    // this.showRelationTooltip = false;
			  },
			  
			// 修改提交
			async editSubmit() {
			  this.submitting = true;
			  try {
			    await this.$refs.addForm.validate();
			    
			    // 确保地址字段正确赋值
			    this.ensureContactAddressFields();
			    
			    console.log('修改提交，conerAddCode参数（areaCode）:', this.addForm.conerAddCode);
			    
			    // 准备提交数据
			    const submitData = {
			      aboId: this.addForm.aboId || 0,
			      aboRhId: this.addForm.aboRhId || 0,
			      age: this.addForm.age || 0,
			      brdy: this.addForm.brdy || '',
			      certType: this.addForm.certType || 0,
			      certno: this.addForm.certno || '',
			      conerAddCode: this.addForm.conerAddCode || '',      // 联系地址编码参数，值为areaCode
			      conerAddName: this.addForm.conerAddName || '',      // 联系地址名称参数
			      conerCertNo: this.addForm.conerCertNo || '',
			      conerCertTypeId: this.addForm.conerCertTypeId || 0,
			      conerName: this.addForm.conerName || '',
			      conerRltsId: this.addForm.conerRltsId || 0,
			      conerTel: this.addForm.conerTel || '',
			      createType: this.addForm.createType || 0,
			      edulBacdId: this.addForm.edulBacdId || 0,
			      id: this.addForm.id || 0,
			      jobId: this.addForm.jobId || 0,
			      lunrBrdy: this.addForm.lunrBrdy || '',
			      mrgState: this.addForm.mrgState || 0,
			      name: this.addForm.name || '',
			      naty: this.addForm.naty || 0,
			      ntlyId: this.addForm.ntlyId || '',
			      phrUnt: this.addForm.phrUnt || 0,
			      prhCostType: this.addForm.prhCostType || 0,
			      prhType: this.addForm.prhType || 0,
			      sex: this.addForm.sex || 0,
			      tel: this.addForm.tel || '',
			      thrNot: this.addForm.thrNot || 0
			    };
			    
			    console.log('修改提交数据:');
			    console.log('conerAddCode参数（areaCode）:', submitData.conerAddCode);
			    
			    const res = await updateDocphr(submitData);
			    
			    if (res.code === 200) {
			      this.$message.success('修改成功！');
			      this.dialogVisible = false;
			      this.resetForm();
			      
			      // 调用父组件刷新数据
			      if (this.parentMethod) {
			        this.parentMethod();
			      }
			    } else {
			      this.$message.error(res.message || '修改失败');
			    }
			  } catch (error) {
			    console.error('表单验证失败:', error);
			    if (!error.response) {
			      this.$message.error('请检查表单填写是否正确');
			    }
			  } finally {
			    this.submitting = false;
			  }
			},
			
			// 联系地址变更处理
			handleContactAddressChange(value) {
			  console.log('联系地址变更，value是areaCode数组:', value);
			  
			  if (value && Array.isArray(value) && value.length > 0) {
			    // 获取完整的路径数组
			    this.contactAddressSelected = value;
			    
			    // 获取选中的最后一个节点（现在就是areaCode）
			    const lastValue = value[value.length - 1];
			    
			    // 设置conerAddCode为最后一个areaCode
			    this.addForm.conerAddCode = lastValue || '';
			    
			    console.log('设置conerAddCode为已选择的areaCode:', this.addForm.conerAddCode);
			  } else {
			    // 清空地址
			    this.addForm.conerAddCode = '';
			    this.contactAddressSelected = [];
			  }
			},
			
			// 从选中数据中提取完整的地址名称路径
			getFullNameRegionFromSelected(selectedArray) {
			  if (!selectedArray || !Array.isArray(selectedArray) || selectedArray.length === 0) {
			    return '';
			  }
			  
			  // 提取每一级的地址名称
			  const nameParts = selectedArray.map(item => {
			    if (typeof item === 'object' && item !== null) {
			      return item.areaName || item.label || '';
			    } else {
			      return '';
			    }
			  }).filter(name => name && name.trim()); // 过滤空值
			  
			  if (nameParts.length === 0) {
			    return '';
			  }
			  
			  // 使用"/"连接各级地址名称
			  return nameParts.join('/');
			},
			
			// 根据地址编码获取地址名称
			getContactAddressNameByCode(areaCode) {
			  // 这里应该根据areaCode调用接口获取地址详情
			  // 由于是简化版本，我们返回一个占位符
			  if (!areaCode) return '';
			  return `联系地址-${areaCode}`;
			},
			
			// 其他原有方法
			handlefoucs(v, i) {
				this.idx = i;
			},
			
			// 获取性别文本
			getSexText(sex) {
			  return this.sexTextMap[sex] || '未知';
			},
			
			// 获取民族文本
			getNatyText(natyId) {
			  if (!natyId) return '--';
			  const natyItem = this.natyOptions.find(item => item.id === natyId);
			  return natyItem ? natyItem.name : '--';
			},
			
			// 获取国籍文本
			getNtlyText(ntlyId) {
			  if (!ntlyId) return '--';
			  const ntlyItem = this.ntlyOptions.find(item => item.id === ntlyId);
			  return ntlyItem ? ntlyItem.name : '--';
			},
			
			// 获取职业文本
			getJobText(jobId) {
			  if (!jobId) return '--';
			  const jobItem = this.jobOptions.find(item => item.id === jobId);
			  return jobItem ? jobItem.name : '--';
			},
			
			// 关联人员下拉框获取焦点
			handleRelationSelectFocus() {
			  if (this.relationOptions.length === 0 && !this.relationLoading) {
			    this.loadRelationOptions();
			  }
			},
			
			// 正常数据复选框变化
			handleNormalChange(value) {
			  this.isNormalData = value;
			  this.relationOptions = [];
			  this.loadRelationOptions();
			},
			
			// 关联人员选择变化
			handleRelationSelectChange(value) {
			  console.log('选择关联人员ID:', value);
			},
			
			// 加载关联人员选项
			async loadRelationOptions() {
			  if (!this.addForm.id) {
			    this.$message.warning('请先保存基本信息');
			    return;
			  }
			  
			  this.relationLoading = true;
			  try {
			    const params = {
			      condition: this.addForm.id, // 当前健康档案ID
			      type: this.isNormalData ? 1 : 2, // 数据类型：1正常数据 2自动生成
			      pageNum: 1,
			      pageSize: 1000 // 设置为较大的值，一次性获取所有数据
			    };
			    
			    console.log('调用docphrList接口，参数:', params);
			    
			    // 调用docphrList接口
			    const res = await docphrList(params);
			    
			    console.log('docphrList接口返回:', res);
			    
			    if (res.code === 200 && res.data) {
			      this.relationOptions = res.data.map(item => ({
			        ...item,
			        // 确保字段名统一
			        id: item.id || 0,
			        name: item.name || '',
			        sex: item.sex || 0,
			        age: item.age || 0,
			        naty: item.naty || 0,
			        ntlyId: item.ntlyId || '',
			        certNo: item.certNo || item.certno || '',
			        jobId: item.jobId || 0
			      }));
			      
			      console.log('成功加载关联人员数据，共', this.relationOptions.length, '条');
			    } else {
			      this.relationOptions = [];
			      console.warn('未找到关联人员数据，接口返回:', res);
			    }
			  } catch (error) {
			    console.error('加载关联人员失败:', error);
			    this.$message.error('加载关联人员失败');
			    this.relationOptions = [];
			  } finally {
			    this.relationLoading = false;
			  }
			},
			
			// 监听下拉框显示/隐藏状态
			handleSelectVisible(visible) {
			  this.showRelationHeader = visible;
			  if (visible && this.relationOptions.length === 0 && !this.relationLoading) {
			    this.loadRelationOptions();
			  }
			},
			
			// 确认添加关联
			async confirmAddRelation() {
			  if (!this.relationForm.relationId) {
			    this.$message.warning('请选择关联人员');
			    return;
			  }
			  
			  // 检查是否关联自己
			  if (this.relationForm.relationId === this.addForm.id) {
			    this.$message.warning('同一人员不能相互关联');
			    return;
			  }
			  
			  try {
			    // 准备请求参数
			    const params = {
			      phrMainId: this.addForm.id, // 当前健康档案ID
			      phrRelationId: this.relationForm.relationId // 关联的健康档案ID
			    };
			    
			    if (this.relationForm.remark) {
			      params.remark = this.relationForm.remark;
			    }
			    
			    let res;
			    if (this.isReRelationMode && this.reRelationRow) {
			      // 重新关联：先删除原有关联，再添加新关联
			      const deleteRes = await deleteRelation({ relationId: this.reRelationRow.id || this.reRelationRow.relationId });
			      if (deleteRes.code === 200) {
			        // 删除成功后添加新关联
			        res = await addRelationPhr(params);
			      } else {
			        this.$message.error(deleteRes.message || '删除原有关联失败');
			        return;
			      }
			    } else {
			      // 添加新关联
			      res = await addRelationPhr(params);
			    }
			    
			    if (res.code === 200) {
			      this.$message.success(this.isReRelationMode ? '重新关联成功' : '添加成功');
			      this.addRelationDialogVisible = false;
			      
			      // 重置表单
			      this.relationForm = {
			        relationId: '',
			        remark: ''
			      };
			      this.isNormalData = true;
			      this.isReRelationMode = false;
			      this.reRelationRow = null;
			      
			      // 重新加载关联数据
			      if (this.addForm.id) {
			        await this.loadRelationData(this.addForm.id);
			      }
			    } else {
			      this.$message.error(res.message || (this.isReRelationMode ? '重新关联失败' : '添加失败'));
			    }
			  } catch (error) {
			    console.error('关联操作失败:', error);
			    this.$message.error(this.isReRelationMode ? '重新关联失败' : '添加失败');
			  }
			},
			
			// 处理编辑模式下的联系地址回显
			async processContactAddressForEdit(data) {
			  console.log('处理联系地址回显，编辑模式数据:', data);
			  
			  // 设置联系地址编码 - 使用接口返回的conerAddCode（areaCode）
			  if (data.conerAddCode) {
			    this.addForm.conerAddCode = data.conerAddCode;
			    
			    console.log('conerAddCode是地址编码:', this.addForm.conerAddCode);
			    
			    // 根据地址编码加载完整的中文地址
			    await this.loadAddressByCode(this.addForm.conerAddCode);
			  } else {
			    this.contactAddressSelected = [];
			  }
			  
			  // 设置联系地址名称
			  if (data.conerAddName) {
			    this.addForm.conerAddName = data.conerAddName;
			    this.contactAddressDetail = data.conerAddName;
			  }
			},
			
			// 根据地址编码加载完整的中文地址
			async loadAddressByCode(areaCode) {
			  if (!areaCode) {
			    console.log('没有地址编码，无法加载地址');
			    this.contactAddressSelected = [];
			    return;
			  }
			  
			  try {
			    console.log('开始根据地址编码加载中文地址:', areaCode);
			    
			    // 清空当前选中
			    this.contactAddressSelected = [];
			    
			    // 根据地址编码解析层级
			    // 假设地址编码格式为：省(2位) + 市(2位) + 区(2位) + 乡(3位) + 村(3位) = 12位
			    if (areaCode.length === 12) {
			      // 解析各级编码
			      const provinceCode = areaCode.substring(0, 2) + '0000000000'; // 省级编码
			      const cityCode = areaCode.substring(0, 4) + '00000000';      // 市级编码
			      const districtCode = areaCode.substring(0, 6) + '000000';    // 区级编码
			      const townCode = areaCode.substring(0, 9) + '000';          // 乡镇编码
			      const villageCode = areaCode;                               // 村社区编码
			      
			      console.log('解析出的各级编码:', {
			        provinceCode, cityCode, districtCode, townCode, villageCode
			      });
			      
			      // 递归加载各级地址
			      await this.recursiveLoadAddress([
			        provinceCode, cityCode, districtCode, townCode, villageCode
			      ], 0);
			    } else {
			      console.warn('地址编码格式不正确，长度不是12位:', areaCode);
			      this.contactAddressSelected = [areaCode];
			    }
			    
			    console.log('加载完成后的contactAddressSelected:', this.contactAddressSelected);
			  } catch (error) {
			    console.error('加载地址失败:', error);
			    this.contactAddressSelected = [areaCode];
			  }
			},
			
			// 递归加载地址
			async recursiveLoadAddress(codes, index) {
			  if (index >= codes.length) {
			    console.log('地址递归加载完成');
			    return;
			  }
			  
			  const currentCode = codes[index];
			  console.log(`递归加载第${index + 1}级地址，编码:`, currentCode);
			  
			  try {
			    // 根据索引确定层级
			    const level = index + 1;
			    let condtion = '';
			    
			    switch(level) {
			      case 1:
			        condtion = '';
			        break;
			      case 2:
			        condtion = 'area_p_code';
			        break;
			      case 3:
			        condtion = 'area_c_code';
			        break;
			      case 4:
			        condtion = 'area_d_code';
			        break;
			      case 5:
			        condtion = 'area_t_code';
			        break;
			      default:
			        condtion = '';
			    }
			    
			    // 确定父级编码
			    const parentCode = index > 0 ? codes[index - 1] : '';
			    
			    // 调用getArea接口
			    const params = {
			      areaCode: parentCode,
			      areaLevel: level,
			      condtion: condtion
			    };
			    
			    console.log(`调用getArea接口，参数:`, params);
			    
			    const res = await getArea(params);
			    
			    if (res.code === 200 && res.data && Array.isArray(res.data)) {
			      // 查找当前编码对应的地址
			      const addressInfo = res.data.find(item => item.areaCode === currentCode);
			      
			      if (addressInfo) {
			        console.log(`找到第${level}级地址:`, addressInfo);
			        
			        // 构建地址对象
			        const addressObject = {
			          value: addressInfo.areaCode,
			          label: addressInfo.areaName,
			          areaCode: addressInfo.areaCode,
			          areaName: addressInfo.areaName
			        };
			        
			        // 将地址信息添加到选中数组
			        this.contactAddressSelected.push(addressObject);
			        
			        // 递归加载下一级
			        await this.recursiveLoadAddress(codes, index + 1);
			      } else {
			        console.warn(`未找到编码为${currentCode}的第${level}级地址`);
			        // 如果找不到，使用编码作为占位符
			        this.contactAddressSelected.push(currentCode);
			        // 继续加载下一级
			        await this.recursiveLoadAddress(codes, index + 1);
			      }
			    } else {
			      console.warn(`获取第${level}级地址失败:`, res);
			      // 如果接口调用失败，使用编码作为占位符
			      this.contactAddressSelected.push(currentCode);
			      // 继续加载下一级
			      await this.recursiveLoadAddress(codes, index + 1);
			    }
			  } catch (error) {
			    console.error(`加载第${index + 1}级地址失败:`, error);
			    // 出错时使用编码作为占位符
			    this.contactAddressSelected.push(currentCode);
			    // 继续加载下一级
			    await this.recursiveLoadAddress(codes, index + 1);
			  }
			},
			
			// 从JSON对象递归加载地址层级
			async loadAddressHierarchyFromJSON(addressArray, index) {
			  if (index >= addressArray.length) {
			    console.log('地址层级加载完成');
			    return;
			  }
			  
			  const currentItem = addressArray[index];
			  console.log(`加载第${index + 1}级地址，数据:`, currentItem);
			  
			  const currentCode = currentItem.areaCode || currentItem.value || currentItem.id || '';
			  if (!currentCode) {
			    console.warn(`第${index + 1}级地址没有编码，跳过`);
			    // 继续加载下一级
			    await this.loadAddressHierarchyFromJSON(addressArray, index + 1);
			    return;
			  }
			  
			  try {
			    // 根据索引确定层级
			    const level = index + 1;
			    let condtion = '';
			    
			    switch(level) {
			      case 1:
			        condtion = '';
			        break;
			      case 2:
			        condtion = 'area_p_code';
			        break;
			      case 3:
			        condtion = 'area_c_code';
			        break;
			      case 4:
			        condtion = 'area_d_code';
			        break;
			      case 5:
			        condtion = 'area_t_code';
			        break;
			      default:
			        condtion = '';
			    }
			    
			    // 确定父级编码
			    const parentCode = index > 0 ? (addressArray[index - 1].areaCode || addressArray[index - 1].value || '') : '';
			    
			    // 调用getArea接口
			    const params = {
			      areaCode: parentCode,
			      areaLevel: level,
			      condtion: condtion
			    };
			    
			    console.log(`调用getArea接口，参数:`, params);
			    
			    const res = await getArea(params);
			    
			    if (res.code === 200 && res.data && Array.isArray(res.data)) {
			      // 查找当前编码对应的地址
			      const addressInfo = res.data.find(item => item.areaCode === currentCode);
			      
			      if (addressInfo) {
			        console.log(`找到第${level}级地址:`, addressInfo);
			        
			        // 构建地址对象
			        const addressObject = {
			          value: addressInfo.areaCode,
			          label: addressInfo.areaName,
			          areaCode: addressInfo.areaCode,
			          areaName: addressInfo.areaName
			        };
			        
			        // 将地址信息添加到选中数组
			        this.contactAddressSelected.push(addressObject);
			        
			        // 递归加载下一级
			        await this.loadAddressHierarchyFromJSON(addressArray, index + 1);
			      } else {
			        console.warn(`未找到编码为${currentCode}的第${level}级地址`);
			        // 如果找不到，使用保存的数据
			        this.contactAddressSelected.push({
			          value: currentItem.areaCode || currentItem.value || '',
			          label: currentItem.areaName || currentItem.label || '',
			          areaCode: currentItem.areaCode || currentItem.value || '',
			          areaName: currentItem.areaName || currentItem.label || ''
			        });
			        // 继续加载下一级
			        await this.loadAddressHierarchyFromJSON(addressArray, index + 1);
			      }
			    } else {
			      console.warn(`获取第${level}级地址失败:`, res);
			      // 如果接口调用失败，使用保存的数据
			      this.contactAddressSelected.push({
			        value: currentItem.areaCode || currentItem.value || '',
			        label: currentItem.areaName || currentItem.label || '',
			        areaCode: currentItem.areaCode || currentItem.value || '',
			        areaName: currentItem.areaName || currentItem.label || ''
			      });
			      // 继续加载下一级
			      await this.loadAddressHierarchyFromJSON(addressArray, index + 1);
			    }
			  } catch (error) {
			    console.error(`加载第${index + 1}级地址失败:`, error);
			    // 出错时使用保存的数据
			    this.contactAddressSelected.push({
			      value: currentItem.areaCode || currentItem.value || '',
			      label: currentItem.areaName || currentItem.label || '',
			      areaCode: currentItem.areaCode || currentItem.value || '',
			      areaName: currentItem.areaName || currentItem.label || ''
			    });
			    // 继续加载下一级
			    await this.loadAddressHierarchyFromJSON(addressArray, index + 1);
			  }
			},
			
			// 递归加载地址层级
			async loadAddressHierarchy(codeArray, index) {
			  if (index >= codeArray.length) {
			    console.log('地址层级加载完成');
			    return;
			  }
			  
			  const currentCode = codeArray[index];
			  console.log(`加载第${index + 1}级地址，编码:`, currentCode);
			  
			  try {
			    // 根据索引确定层级
			    const level = index + 1;
			    let condtion = '';
			    
			    switch(level) {
			      case 1:
			        condtion = '';
			        break;
			      case 2:
			        condtion = 'area_p_code';
			        break;
			      case 3:
			        condtion = 'area_c_code';
			        break;
			      case 4:
			        condtion = 'area_d_code';
			        break;
			      case 5:
			        condtion = 'area_t_code';
			        break;
			      default:
			        condtion = '';
			    }
			    
			    // 确定父级编码
			    const parentCode = index > 0 ? codeArray[index - 1] : '';
			    
			    // 调用getArea接口
			    const params = {
			      areaCode: parentCode,
			      areaLevel: level,
			      condtion: condtion
			    };
			    
			    console.log(`调用getArea接口，参数:`, params);
			    
			    const res = await getArea(params);
			    
			    if (res.code === 200 && res.data && Array.isArray(res.data)) {
			      // 查找当前编码对应的地址
			      const addressInfo = res.data.find(item => item.areaCode === currentCode);
			      
			      if (addressInfo) {
			        console.log(`找到第${level}级地址:`, addressInfo);
			        
			        // 将地址信息添加到选中数组
			        this.contactAddressSelected.push({
			          value: addressInfo.areaCode,
			          label: addressInfo.areaName,
			          areaCode: addressInfo.areaCode,
			          areaName: addressInfo.areaName
			        });
			        
			        // 递归加载下一级
			        await this.loadAddressHierarchy(codeArray, index + 1);
			      } else {
			        console.warn(`未找到编码为${currentCode}的第${level}级地址`);
			        // 如果找不到，使用编码作为占位符
			        this.contactAddressSelected.push(currentCode);
			        // 继续加载下一级
			        await this.loadAddressHierarchy(codeArray, index + 1);
			      }
			    } else {
			      console.warn(`获取第${level}级地址失败:`, res);
			      // 如果接口调用失败，使用编码作为占位符
			      this.contactAddressSelected.push(currentCode);
			      // 继续加载下一级
			      await this.loadAddressHierarchy(codeArray, index + 1);
			    }
			  } catch (error) {
			    console.error(`加载第${index + 1}级地址失败:`, error);
			    // 出错时使用编码作为占位符
			    this.contactAddressSelected.push(currentCode);
			    // 继续加载下一级
			    await this.loadAddressHierarchy(codeArray, index + 1);
			  }
			},
			
			// 取消关联
			async handleCancelRelation(row) {
				try {
					await this.$confirm('确定要取消这条关联记录吗？', '提示', {
						type: 'warning'
					});
					
					// 获取要删除的关联记录id
					const relationId = row.id || row.relationId;
					
					if (!relationId) {
						this.$message.warning('无法获取关联记录ID');
						return;
					}
					
					// 调用取消关联接口
					const res = await deleteRelation({ relationId: relationId });
					
					if (res.code === 200) {
						// 从本地数据中移除
						const index = this.relationData.findIndex(item => item.id === relationId || item.relationId === relationId);
						if (index !== -1) {
							this.relationData.splice(index, 1);
						}
						this.$message.success('取消关联成功');
					} else {
						this.$message.error(res.message || '取消关联失败');
					}
				} catch (error) {
					if (error !== 'cancel') {
						console.error('取消关联失败:', error);
					}
				}
			},
			
			// 过敏记录相关方法
			tableBtnHandClick() {
			  this.isEditAllergyMode = false;
			  this.currentEditAllergyIndex = -1;
			  this.currentEditAllergyName = '';
			  
			  // 如果是编辑模式，从已保存的数据中加载
			  if (this.mode === 'edit' || this.mode === 'view') {
			    this.tempAiseChosedData = [...this.aiseChosedData];
			  } else {
			    this.tempAiseChosedData = [];
			  }
			  
			  this.aisedialogVisible = true;
			},
			
			// 编辑过敏原
			handleEditAllergy(row, index) {
			  this.isEditAllergyMode = true;
			  this.currentEditAllergyIndex = index;
			  this.currentEditAllergyName = row.name;
			  
			  // 将当前行数据添加到临时已选数据
			  this.tempAiseChosedData = [row];
			  this.currentTable = row;
			  
			  this.aisedialogVisible = true;
			},
			
			// 移除过敏原
			async handleRemoveAllergy(row) {
			  try {
			    await this.$confirm('确定要移除这条过敏记录吗？', '提示', {
			      type: 'warning'
			    });
			    
			    // 明确获取过敏记录的唯一标识
			    const allergyId = row.aiseId; // 过敏记录的唯一标识
			    
			    if (!allergyId) {
			      this.$message.warning('无法获取过敏记录ID');
			      return;
			    }
			    
			    console.log(allergyId, 'allergyIdallergyIdallergyId');
			    
			    // 调用删除接口
			    if (allergyId) {
			      const res = await deleteDocphr({ ids: allergyId });
			      if (res.code === 200) {
			        // 从本地数据中移除
			        const index = this.aiseChosedData.findIndex(item => item.id === allergyId);
			        if (index !== -1) {
			          this.aiseChosedData.splice(index, 1);
			        }
			        this.$message.success('移除成功');
			      } else {
			        this.$message.error(res.message || '移除失败');
			      }
			    } else {
			      // 如果没有id，直接从本地数据中移除
			      const index = this.aiseChosedData.findIndex(item => 
			        item.aiseId === row.aiseId && 
			        item.algsDese === row.algsDese
			      );
			      if (index !== -1) {
			        this.aiseChosedData.splice(index, 1);
			        this.$message.success('移除成功');
			      }
			    }
			  } catch (error) {
			    if (error !== 'cancel') {
			      console.error('移除过敏记录失败:', error);
			    }
			  }
			},
			
			// 获取过敏原列表
			async getAise() {
			  try {
			    let res = await aiseList();
			    this.dataFrom = 1;
			    this.aiseData = res.data.map(v => { 
			      return { 
			        ...v,
			        dataSource: this.dataFrom,
			        // 确保有必要的字段
			        id: v.id || v.code,
			        name: v.name || '',
			        code: v.code || '',
			        type: v.type || 2
			      } 
			    });
			    
			    // 构建过敏原名称映射
			    this.aiseData.forEach(item => {
			      this.aiseNameMap[item.id] = item.name;
			    });
			  } catch (error) {
			    console.error('获取过敏信息失败:', error);
			  }
			},
			
			// 过敏原对话框确认
			async aiseDialogConfirm() {
			  if (this.tempAiseChosedData.length === 0) {
			    this.$message.warning('请至少选择一条过敏原记录');
			    return;
			  }
			  
			  try {
			    // 如果是新增模式，直接更新显示
			    if (this.mode === 'add') {
			      this.aiseChosedData = [...this.tempAiseChosedData];
			      this.$message.success(`已选择${this.tempAiseChosedData.length}条过敏记录`);
			    } 
			    // 如果是编辑模式
			    else if (this.mode === 'edit' && this.addForm.id) {
			      // 如果是编辑单条记录
			      if (this.isEditAllergyMode && this.currentEditAllergyIndex !== -1) {
			        if (this.tempAiseChosedData.length > 0) {
			          const newData = this.tempAiseChosedData[0];
			          const aiseName = this.getAiseNameById(newData.id || newData.code);
			          
			          // 更新原数据
			          this.aiseChosedData[this.currentEditAllergyIndex] = {
			            ...newData,
			            name: aiseName,
			            aiseName: aiseName
			          };
			          
			          this.$message.success('修改成功');
			        }
			      } 
			      // 如果是新增多条记录
			      else {
			        // 准备调用addPhrAlg接口的数据
			        const phrAlgData = this.tempAiseChosedData.map(item => ({
			          aiseId: item.id || item.code,
			          algsDese: this.generateAlgsDese(item),
			          dataSource: item.dataSource || 1,
			          patId: this.addForm.id,
			          type: item.type || 2
			        }));
			        
			        // 调用接口添加过敏记录
			        const res = await addPhrAlg(phrAlgData);
			        if (res.code === 200) {
			          // 重新加载过敏记录
			          const detailRes = await aiseDetails({ id: this.addForm.id });
			          if (detailRes.code === 200 && detailRes.data.rhrAlgs) {
			            this.aiseChosedData = detailRes.data.rhrAlgs.map(item => {
			              const aiseName = this.getAiseNameById(item.aiseId);
			              return {
			                ...item,
			                id: item.aiseId,
			                name: aiseName,
			                aiseName: aiseName
			              };
			            });
			          }
			          this.$message.success(`已添加${this.tempAiseChosedData.length}条过敏记录`);
			        } else {
			          this.$message.error(res.message || '添加过敏记录失败');
			        }
			      }
			    }
			    
			    this.aisedialogVisible = false;
			    this.isEditAllergyMode = false;
			    this.currentEditAllergyIndex = -1;
			    this.currentEditAllergyName = '';
			  } catch (error) {
			    console.error('处理过敏原数据失败:', error);
			    this.$message.error('操作失败');
			  }
			},
			
			// 生成过敏描述
			generateAlgsDese(item) {
			  const aiseName = this.getAiseNameById(item.id || item.code);
			  
			  if (item.type === 1) {
			    // 药品类型
			    if (item.dataSource === 2) {
			      // 皮试结果
			      return `${aiseName}皮试阳性`;
			    } else {
			      // 手工选择
			      return `${aiseName}过敏`;
			    }
			  } else {
			    // 其他类型
			    return `${aiseName}过敏`;
			  }
			},
			
			// 表格行单击
			handleCurrentChange(val){
			  this.currentTable = val
			},
			
			// 选择单行
			selectSingleRow(row) {
			  // 检查是否已存在
			  const exists = this.tempAiseChosedData.some(item => 
			    item.id === row.id || 
			    item.code === row.code
			  );
			  
			  if (!exists) {
			    this.tempAiseChosedData.push(row);
			  } else {
			    this.$message.warning('该过敏原已选择');
			  }
			},
			
			// 表格行双击
			selectRows(v){
			  // 检查是否已存在
			  const exists = this.tempAiseChosedData.some(item => 
			    item.id === v.id || 
			    item.code === v.code
			  );
			  
			  if (!exists) {
			    this.tempAiseChosedData.push(v);
			  } else {
			    this.$message.warning('该过敏原已选择');
			  }
			},
			
			// 移除临时过敏原
			removeTempAllergy(index) {
			  this.tempAiseChosedData.splice(index, 1);
			},
			
			// 关闭过敏原对话框
			aiseHandleClose(done) {
			  done();
			},
			
			// 数据来源选择
			dataFromHandle(val){
			  this.dataFrom = val
			  this.aiseData.map(v=> v.dataSource = val)
			}
		}
		}
		</script>
		
		<style lang="less" scoped>
		/deep/ .el-dialog__header {
		  padding: 12px 20px;
		  background-color: #007bb0;
		}
		
		/deep/ .el-dialog__title {
		  font-size: 16px;
		  color: #fff;
		  font-weight: bold;
		}
		
		/deep/ .el-dialog__headerbtn .el-dialog__close {
		  color: #fff;
		}
		
		/deep/ .el-dialog__body {
		  padding: 20px;
		  max-height: 70vh;
		  overflow-y: auto;
		}
		/* 级联选择器样式 */
		/deep/ .address-cascader {
		  .el-cascader-menu {
		    min-width: 120px;
		  }
		  
		  .el-cascader-node {
		    font-size: 12px;
		  }
		  
		  /* 确保显示完整路径 */
		  .el-cascader__input {
		    overflow: hidden;
		    text-overflow: ellipsis;
		    white-space: nowrap;
		  }
		}
		.form {
		  /deep/ .el-tabs__content {
		  }
		  
		  // 关键修改：紧凑的表单项样式
		  /deep/ .compact-form-item {
		    margin-bottom: 6px !important;
		    display: flex;
		    align-items: center;
		  }
		  
		  /deep/ .compact-form-item .el-form-item__label {
		    font-size: 12px;
		    color: #606266;
		    font-weight: 500;
		    line-height: 28px;
		    padding-right: 8px; /* 减少右侧内边距 */
		    text-align: right;
		    flex-shrink: 0;
		  }
		  
		  /deep/ .compact-form-item .el-form-item__content {
		    flex: 1;
		    line-height: 28px;
		    margin-left: 8px !important; /* 减少label和输入框之间的间距 */
		  }
		  
		  /deep/ .el-input--mini .el-input__inner {
		    height: 28px;
		    line-height: 28px;
		  }
		  
		  /deep/ .el-select {
		    width: 100%;
		  }
		  
		  /deep/ .el-date-editor {
		    width: 100%;
		  }
		  
		  /deep/ .el-cascader {
		    width: 100%;
		  }
		  
		  .headerForm {
		    border: 1px solid #ebeef5;
		    border-radius: 4px;
		    padding: 16px; /* 减少内边距 */
		    margin-bottom: 16px;
		  }
		  
		  .mainForm {
		    border: 1px solid #ebeef5;
		    border-radius: 4px;
		    padding: 16px; /* 减少内边距 */
		  }
		  
		  // 过敏记录容器
		  .allergy-container, .relation-container {
		    border: 1px solid #ebeef5;
		    border-radius: 4px;
		  }
		}
		
		// 关联选择框样式
		.relation-select-header {
		  background-color: #f5f7fa;
		  padding: 5px 0;
		  font-weight: bold;
		  border-bottom: 1px solid #ebeef5;
		  position: sticky;
		  top: 0;
		  z-index: 10;
		  display: flex;
		  width: 100%;
		}
		
		.relation-header-cell {
		  flex: 1;
		  text-align: center;
		  padding: 0 5px;
		  font-size: 12px;
		  color: #606266;
		  overflow: hidden;
		  text-overflow: ellipsis;
		}
		
		.relation-option-content {
		  display: flex;
		  width: 100%;
		  padding: 3px 0;
		}
		
		.relation-data-cell {
		  flex: 1;
		  text-align: center;
		  padding: 0 5px;
		  font-size: 12px;
		  color: #333;
		  overflow: hidden;
		  border: 1px solid #ccc;
		  text-overflow: ellipsis;
		}
		
		// 禁用选项的提示样式
		/deep/ .el-select-dropdown__item.is-disabled {
		  cursor: not-allowed;
		  opacity: 0.6;
		  position: relative;
		}
		
		/deep/ .el-select-dropdown__item.is-disabled:hover::after {
		  content: '不能关联自己哦';
		  position: absolute;
		  top: 100%;
		  left: 50%;
		  transform: translateX(-50%);
		  background-color: #333;
		  color: #fff;
		  padding: 4px 8px;
		  border-radius: 4px;
		  font-size: 12px;
		  white-space: nowrap;
		  z-index: 1000;
		  margin-top: 5px;
		}
		
		/* 关联选择框下拉框自定义样式 */
		/deep/ .relation-select-popper {
		  .el-select-dropdown__list {
		    padding-top: 0;
		  }
		  
		  .el-select-dropdown__item {
		    padding: 0;
		    
		    &.selected {
		      background-color: #f5f7fa;
		    }
		  }
		  
		  .relation-header-container {
		    background-color: #f5f7fa;
		    padding: 5px 0;
		    font-weight: bold;
		    border-bottom: 1px solid #ebeef5;
		    position: sticky;
		    top: 0;
		    z-index: 10;
		    width: 100%;
		  }
		  
		  .relation-header-row {
		    display: flex;
		    width: 100%;
		  }
		  
		  .relation-header-cell {
		    flex: 1;
		    text-align: center;
		    padding: 0 5px;
		    font-size: 12px;
		    color: #606266;
		    overflow: hidden;
		    text-overflow: ellipsis;
		  }
		  
		  .relation-option-content {
		    display: flex;
		    width: 100%;
		    padding: 3px 0;
		  }
		  
		  .relation-data-cell {
		    flex: 1;
		    text-align: center;
		    padding: 0 5px;
		    font-size: 12px;
		    color: #333;
		    overflow: hidden;
		    text-overflow: ellipsis;
		  }
		  
		  .el-scrollbar {
		    .el-select-dropdown__wrap {
		      max-height: 300px;
		    }
		  }
		}
		
		// 过敏原选择对话框样式
		.getAise {
		  /deep/ .el-dialog__header {
		    padding: 8px;
		    background-color: #007bb0;
		  }
		  /deep/ .el-dialog__body {
		    padding: 18px;
		  }
		  /deep/ .el-dialog__title {
		    font-size: 12px;
		    color: #fff;
		  }
		  /deep/ .el-dialog__headerbtn {
		    top: 15px;
		  }
		  /deep/ .el-dialog__headerbtn .el-dialog__close {
		    color: #fff;
		  }
		  /deep/ .el-dialog__headerbtn .el-dialog__close:hover {
		    background-color: brown;
		  }
		  .aiseTable {
		    .aiseTable-header {
		      display: flex;
		      align-items: center;
		      justify-content: space-between;
		      span {
		        color: #000;
		      }
		      /deep/ .el-input {
		        width: 188px;
		      }
		      /* 移除选择按钮 */
		      .el-button {
		        display: none;
		      }
		    }
		    .aiseTable-main {
		      .table {
		        margin-top: 12px;
		        /deep/ .el-table .el-table__cell {
		          font-size: 12px;
		          color: #000;
		          text-align: center;
		        }
		        /* 自定义高亮颜色 */
		        ::v-deep .el-table__body tr.current-row > td {
		          background-color: #00557f !important;
		          color: #f9f9f9; /* 可选：修改文字颜色 */
		        }
		      }
		      // 已选过敏原
		      .tableChosed {
		        margin-top: 12px;
		        /deep/ .el-table {
		          margin-top: 12px;
		        }
		        /deep/ .el-table .el-table__cell {
		          font-size: 12px;
		          color: #000;
		          text-align: center;
		        }
		        /* 自定义高亮颜色 */
		        ::v-deep .el-table__body tr.current-row > td {
		          background-color: #ffaa7f !important;
		          color: #f9f9f9; /* 可选：修改文字颜色 */
		        }
		      }
		    }
		  }
		}
		
		// 响应式调整
		@media (max-width: 1200px) {
		  .form {
		    /deep/ .el-col {
		      width: 100% !important;
		    }
		  }
		}
		</style>